import PageHeader from '~/components/PageHeader';
import Stack from '~/components/ui/Stack';
import BalanceBlock from './BalanceBlock';
import PendingTransactionsBlock from './PendingTransactionsBlock';
import SwitchPlanBlock from './SwitchPlanBlock';

function Subscription() {
  return (
    <Stack col gap={6} className="flex-1">
      <PageHeader id="subscription" />
      <PendingTransactionsBlock />
      <SwitchPlanBlock />
      <BalanceBlock />
    </Stack>
  );
}

export default Subscription;
